(function () {
  var SELECTOR = '[data-pdp-rhythm-section]';

  function isRenderable(section) {
    if (!section || section.hidden) return false;
    if (section.offsetParent === null && section.getClientRects().length === 0) return false;
    return true;
  }

  function assignPdpTones() {
    var sections = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    var autoIndex = 0;

    sections.forEach(function (section) {
      if (!isRenderable(section)) return;

      var mode = (section.getAttribute('data-tone-mode') || 'auto').toLowerCase();
      if (mode === 'light' || mode === 'dark') {
        section.setAttribute('data-pdp-tone', mode);
        return;
      }

      section.setAttribute('data-pdp-tone', autoIndex % 2 === 0 ? 'light' : 'dark');
      autoIndex += 1;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', assignPdpTones);
  } else {
    assignPdpTones();
  }

  document.addEventListener('shopify:section:load', assignPdpTones);
  document.addEventListener('shopify:section:unload', assignPdpTones);
  document.addEventListener('shopify:section:select', assignPdpTones);
  window.addEventListener('pageshow', assignPdpTones);
})();
